import React, { useState } from "react";
import "./StickerBook.css";
import { StickerPage } from "./StickerPage";

export const StickerBook = () => {
  const [currentPage, setCurrentPage] = useState(1);

  // Each "sheet" represents a physical piece of paper with a front and back
  // Colors updated to Hex codes for Vanilla CSS usage
  const sheets = [
    {
      id: 1,
      front: {
        title: "The Beginning",
        content:
          "Welcome to the interactive flipbook. Click the arrows or the pages to turn.",
        bgColor: "#4f46e5", // indigo-600

        textColor: "#ffffff",
      },
      back: {
        title: "Chapter 1",
        content: "Deep in the digital forest, pixels began to dance...",
        bgColor: "#ffffff", // white

        textColor: "#1e293b", // slate-800
      },
    },
    {
      id: 2,
      front: {
        title: "The Journey",
        content:
          "The code flowed like a river, creating paths where there were none.",
        bgColor: "#10b981", // emerald-500

        textColor: "#ffffff",
      },
      back: {
        title: "Chapter 2",
        content: "Algorithms whispered secrets to the wind.",
        bgColor: "#fff7ed", // orange-50

        textColor: "#1e293b",
      },
    },
    {
      id: 3,
      front: {
        title: "The Discovery",
        content: "A hidden component was found, shining with CSS transforms.",
        bgColor: "#f43f5e", // rose-500

        textColor: "#ffffff",
      },
      back: {
        title: "Chapter 3",
        content: "Perspective changed everything.",
        bgColor: "#f1f5f9", // slate-100

        textColor: "#1e293b",
      },
    },
    {
      id: 4,
      front: {
        title: "The Climax",
        content: "With a 180-degree turn, the world flipped upside down.",
        bgColor: "#fbbf24", // amber-400

        textColor: "#ffffff",
      },
      back: {
        title: "Chapter 4",
        content: "But the z-index held strong, keeping order in chaos.",
        bgColor: "#f4f4f5", // zinc-100

        textColor: "#1e293b",
      },
    },
    {
      id: 5,
      front: {
        title: "The End",
        content: "And so, the DOM tree stood tall and reactive forever after.",
        bgColor: "#1e293b", // slate-800

        textColor: "#ffffff",
      },
      back: {
        title: "Credits",
        content: "Built with React & Vanilla CSS 3D Transforms.",
        bgColor: "#0f172a", // slate-900

        textColor: "#cbd5e1", // slate-300
      },
    },
  ];

  const totalSheets = sheets.length;

  const handleNext = () => {
    if (currentPage < totalSheets) {
      setCurrentPage((prev) => prev + 1);
    }
  };

  const handlePrev = () => {
    if (currentPage > 0) {
      setCurrentPage((prev) => prev - 1);
    }
  };

  // Logic to calculate z-index ensures pages stack correctly
  const getZIndex = (index) => {
    if (index < currentPage) {
      return index; // Left stack: Ascending z-index
    }
    return totalSheets - index; // Right stack: Descending z-index
  };

  return (
    <div className="sticker-app-container">
      {/* Vanilla CSS Styles */}

      <div className="sticker-header">
        <h1>My Sticker Book</h1>
        <p>Collect all the Stickers to Earn Robux</p>
      </div>

      {/* The Book Scene */}
      <div className="sticker-book-scene">
        <div className={`sticker-book ${currentPage > 0 ? "is-open" : ""}`}>
          {sheets.map((sheet, index) => (
            <div
              key={sheet.id}
              className={`sticker-sheet ${
                index < currentPage ? "flipped" : ""
              }`}
              style={{ zIndex: getZIndex(index) }}
              onClick={() => {
                if (index === currentPage) handleNext();
                if (index === currentPage - 1) handlePrev();
              }}
            >
              {/* Front of the page */}
              <div
                className="face front"
                style={{
                  backgroundColor: sheet.front.bgColor,
                  color: sheet.front.textColor,
                }}
              >
                <div className="content-container">
                  <StickerPage pageIndex={index * 2 + 1} />
                </div>
              </div>

              {/* Back of the page */}
              <div
                className="face back"
                style={{
                  backgroundColor: sheet.back.bgColor,
                  color: sheet.back.textColor,
                }}
              >
                <div className="content-container">
                  <StickerPage pageIndex={index * 2} />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="tip-text">
        Tip: Complete the Quests Every Day to Get More Stickers.
      </div>
    </div>
  );
};
